<div class="default-sign-image-config">
  <h5 class="config-title">{{'digital_certificate_management.default_sign_image.title' | translate}}</h5>

  <nz-tabset [nzTabPosition]="'top'" [nzType]="'card'" [nzSelectedIndex]="activeTab"
             (nzSelectChange)="onTabChange($event.index)">
    <!-- Tab 1: Ảnh mặc định hệ thống -->
    <nz-tab [nzTitle]="tabSystemImage">
      <ng-template #tabSystemImage>{{
        'enterprise_contract.image_signing.new_tab.system_image' | translate
        }}
      </ng-template>
      <div class="tab-content system-image-tab">
        <app-image-sign-config [selectedCert]="selectedCertProxy"
                               [signConfig]="signConfig"
                               [signMethod]="enumSignMethod"
                               [scopeType]="0"
                               [domRenderImage]="domRenderImageProxy"
                               [isHiddenLabel]="true"
                               (eventConfirmChangeSignatureImage)="onSignConfigChange()">
          <!-- chiếu ảnh hệ thống đã gen vào khung preview (ng-content) của image-sign-config -->
          <img *ngIf="generatedSystemImage" [src]="generatedSystemImage" class="generated-system-image" alt=""/>
        </app-image-sign-config>
      </div>
    </nz-tab>

    <!-- Tab 2: Ảnh ký (upload) -->
    <nz-tab [nzTitle]="tabUploadImage">
      <ng-template #tabUploadImage>{{
        'enterprise_contract.image_signing.new_tab.image_signature' | translate
        }}
      </ng-template>
      <div class="tab-content upload-tab">
        <div class="clearfix nz-upload-clearfix">
          <nz-upload [nzAccept]="'image/jpeg,image/jpg,image/png'"
                     [nzDisabled]="isDisabled"
                     class="avatar-uploader"
                     [nzCustomRequest]="dummyRequest" nzName="avatar" nzListType="picture-card"
                     [nzShowUploadList]="false"
                     [nzBeforeUpload]="beforeUpload">
            <ng-container *ngIf="!uploadImageBase64">
              <i class="upload-icon" nz-icon [nzType]="loading ? 'loading' : 'plus'"></i>
              <div class="ant-upload-text">Upload</div>
            </ng-container>
            <img *ngIf="uploadImageBase64" [src]="sanitizeUrl(uploadImageBase64)"
                 style="max-height: 300px; max-width: 600px;"/>
          </nz-upload>
          <div *ngIf="uploadImageBase64" style="text-align:right; padding: 0 1rem 0.5rem;">
            <i class="fa fa-trash" (click)="deleteUploadImage()" aria-hidden="true"
               matTooltip="{{'tooltips.delete' | translate}}"></i>
          </div>
        </div>
        <!-- hướng dẫn upload đặt dưới ảnh, tách 2 dòng — tái sử dụng key có sẵn của màn ký duyệt -->
        <span class="guiding-info">{{'title.upload_image_sign_guiding1' | translate}}
          <br />{{'title.upload_image_sign_guiding2' | translate}}</span>
        <mat-error *ngIf="wrongFileFormat">
          {{'messages.only_accept_png_jpg' | translate}}
        </mat-error>
        <mat-error *ngIf="fileTooLarge">
          {{'messages.image_must_than_2m' | translate}}
        </mat-error>
      </div>
    </nz-tab>

    <!-- Tab 3: Vẽ chữ ký -->
    <nz-tab [nzTitle]="tabDrawSignature">
      <ng-template #tabDrawSignature>{{
        'enterprise_contract.image_signing.new_tab.draw_signature' | translate
        }}
      </ng-template>
      <div class="tab-content draw-tab">
        <div class="d-flex justify-content-center">
          <app-canvas [canvasWidth]="canvasWidth" [canvasHeight]="canvasHeight"
                      [isConfigSignDefault]="true"
                      [restoredImage]="toDataUrl(savedDrawImageBase64)"
                      (applySignatureImage)="applyDrawImage($event)"
                      (canvasCleared)="applyDrawImage(null)"></app-canvas>
        </div>
      </div>
    </nz-tab>
  </nz-tabset>
</div>
<!-- node render fallback html-to-image cho image-sign-config -->
<div #previewContainer class="preview-container"></div>
